import React, { Fragment, useState,useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import swal from 'sweetalert';
import axios from "axios";
import { Badge } from "react-bootstrap";
import { IMAGES, SVGICON } from '../jsx/constant/theme';
import { useParams } from 'react-router-dom';
import InviteCustomer4 from './Invoiceextendrepairorderold';

import Cars from './cars';
import product1 from "../images/product/1.jpg";
import product2 from "../images/product/2.jpg";
import product3 from "../images/product/3.jpg";
import product4 from "../images/product/4.jpg";
import tab1 from "../images/tab/1.jpg";
import tab2 from "../images/tab/2.jpg";
import tab3 from "../images/tab/3.jpg";
import tab4 from "../images/tab/4.jpg";
import {
  Row,
  Table,
  Col,
  Card,
  Popover,
  Tooltip,
  OverlayTrigger,
  Button,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tab, Nav, ListGroup } from "react-bootstrap";
 import { Modal } from 'react-bootstrap';

const messageBlog = [
  { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' },
  { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' },
  { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' },
  { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' },
  { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' },
  { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }
];

const Orders = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const {VehicleID } = useParams(); // Extract CustomerID from the URL
  const invite4 = useRef();

  const [startDate, setStartDate] = useState(new Date());
  const [inviteModal, setInviteModal] = useState("hidden");
  const [inviteModal1, setInviteModal1] = useState(true);
  const [listItem, setlistItem] = React.useState([])
  const [listItem1, setlistItem1] = useState([])
  const [vehicle, setvehicle] = useState([]);

  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal("hidden")
      setInviteModal1(true)

    }
  }));
  
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');

  // Parse the JSON string back to an array
  const userPermissions = JSON.parse(userPermissionsJSON);
  // Function to search for permissions for a specific page
  function getActionsForPage(pageName) {
    // Find the permissions object for the given page
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
  console.log('actionsForPage',pagePermissions); 
  
    // If permissions for the page are found, return the actions
    if (pagePermissions) {
        return pagePermissions.action;
    } else {
   navigate('/dashboard_1')
  
        return [];
    }
  }
  useEffect(() => {
    // Fetch invoices for the given repair order
    const fetchInvoices = async () => {
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/vehicles/${VehicleID}`);
            setvehicle(response.data);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        } finally {
         }
    };
    fetchrepairorder()
    fetchInvoices();
}, [VehicleID]);
const fetchrepairorder = async () => {
  try {
      const response = await axios.get(`https://subk.education.com.ly/back/api/getByRepairOrderId/${VehicleID}`);
      setlistItem1(response.data);
  } catch (error) {
      console.error("Error fetching invoices:", error);
  } finally {
   }
};

const [datareparorder, setdatareparorder] = useState([]);
const [datareparorderDetails, setdatareparorderDetails] = useState([]);
const EditData5558 = async (e, id) => {
  try {
    const response = await axios.get(`https://subk.education.com.ly/back/api/repairOrder/${id}`);
    setdatareparorder(response.data.RepairOrder);
    setdatareparorderDetails(response.data.RepairOrder.repair_details);

    console.log('de', response.data.RepairOrder.repair_details)
    console.log('MainOrde', response.data.RepairOrder)
    // Assuming the response data is structured correctly
  } catch (error) {
    console.error('Error fetching repair order:', error);
  }
  invite4.current.showInviteModal()


}
  // Usage   vehicles
  const pageName = 'First';
  const actionsForPage = getActionsForPage(pageName);

  const cardBlog = [
    {
        svg: vehicle?.Photo || 'default.svg', // Safe access with fallback
        number: `${vehicle?.make?.MakeName || 'Unknown Make'}-${vehicle?.vehicle_model?.ModelName || 'Unknown Model'}-${vehicle?.EngineNumber || 'Unknown Engine'}-${vehicle?.LicensePlate || 'Unknown Plate'}`, 
        title: vehicle?.Color || 'Unknown Color', // Safe access with fallback
        changetheme: 'success'
    }
];
 const netwrokBlog = [
  {image:IMAGES.dribble, title:'Dribble', price:'12,348', bg:'primary' , percent:'+36' },
  {image:IMAGES.facebook, title:'Facebook', price:'10,048', bg:'danger' , percent:'+33' },
  {image:IMAGES.instagram, title:'Instagram', price:'09,059', bg:'info' , percent:'-10' },
 
];
  return (

    <>
    <div  className="form-label" id="exampleModal1" style={{ visibility: { inviteModal } }} centered>

      <div className="container-fluid " style={{padding:'0.500rem'}}>
      <div className="row">
                    {cardBlog.map((item, ind)=>(
                        <div className="col-xl-12" key={ind}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className={`icon-box icon-box-lg rounded-circle bg-${item.changetheme}-light`} >
                                        <img className="img-fluid rounded-circle " src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo}`} alt=""width={50} />

                                                          
                                        </div>
                                        <div className="total-projects ms-3">
                                            <h6 className={`count text-${item.changetheme}`}>{item.number}</h6> 
                                            <span>{item.title}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                 
                  
                </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card mb-0 h-auto">
              <div className="card-body p-0">
              
                <div className="row gx-0">
                  <div className="col-xl-12 col-xxl-12 col-lg-12">
                  <div className="dlab-scroll  pt-3 ps-2">
               
                    <Tab.Container defaultActiveKey={'tools'}>
                      <div role="toolbar" className="toolbar ms-1 ms-sm-0">
                        <div className="saprat">
                          <div className="d-flex align-items-center">

                            <Nav as="ul" className="nav nav-pills" id="pills-tab" role="tablist">
                             
                            <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                <Nav.Link as="button" eventKey={'tools'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                <i  className="fa-solid fa-globe"></i>   بيانات السياره                           </Nav.Link>
                              </Nav.Item>
                              
                              
                              <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                <Nav.Link as="button" eventKey={'cars'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                <i  className="fa-solid fa-car"></i>    سجل الخدمات                            </Nav.Link>
                              </Nav.Item> 

                               
                            </Nav>

                          </div>

                        </div>
                      </div>
                      {/** Single Message */}


                      <Tab.Content>
                      
                     
                        <Tab.Pane eventKey={'tools'}>
                          <div className="row mt-2">
                         
                                  
                                  
                                     <div className="col-xl-3 col-xxl-6 col-md-6 col-sm-6">
                                    <div className="card">
                                    <div className="modal-header">
                    <h1 className="modal-title fs-5"> صور السيارة  </h1>
                                 </div>
                    <div className="col-xl-12 col-lg-12  col-md-12 p-3">
							{/* Tab panes */}
								<Tab.Container defaultActiveKey="first">
									<Tab.Content>
										<Tab.Pane eventKey="first">
                    <div className="blog-img image-hight" style={{ border: 'black dashed 1px', height: '200px' }}>
                    {/* <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className="form-label">Photo:</label>
    <label>
      <img src={vehicle.Photo || '/default-image.png'} alt="Vehicle" style={{ maxWidth: '100%' }} />
    </label>
  </div> */}  

											<img className="img-fluid rounded" style={{ height: '200px', width: '-moz-available' }} src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo}`}alt="" />
                      </div>
										</Tab.Pane>
										<Tab.Pane eventKey="second">
                    <div className="blog-img image-hight" style={{ border: 'black dashed 1px', height: '200px' }}>

											<img className="img-fluid rounded" style={{ height: '200px', width: '-moz-available' }} src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo2}`} alt="" />
                      </div>
										</Tab.Pane>
										<Tab.Pane eventKey="third">
                    <div className="blog-img image-hight" style={{ border: 'black dashed 1px', height: '200px' }}>

											<img className="img-fluid rounded" style={{ height: '200px', width: '-moz-available' }} src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo3}`} alt="" />
                      </div>
                  	</Tab.Pane>
										<Tab.Pane eventKey="four">
                    <div className="blog-img image-hight" style={{ border: 'black dashed 1px', height: '200px' }}>

											<img className="img-fluid rounded"  style={{ height: '200px', width: '-moz-available' }} src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo4}`} alt="" />
                      </div>
                  	</Tab.Pane>
									</Tab.Content>
									<div className="tab-slide-content new-arrival-product mb-4 mb-xl-0">
									{/* Nav tabs */}
										<Nav as="ul" className="nav slide-item-list mt-3" role="tablist">
											<Nav.Item as="li">
												<Nav.Link as="a" eventKey="first" to="#first">
													<img className="img-fluid" src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo}`} alt=""width={50} />
												</Nav.Link>
											</Nav.Item>
											<Nav.Item as="li">
												<Nav.Link as="a" eventKey="second" to="#second">
													<img className="img-fluid" src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo2}`} alt="" width={50}/>
												</Nav.Link>
											</Nav.Item>
											<Nav.Item as="li">
												<Nav.Link as="a" eventKey="third" to="#third">
													<img  className="img-fluid" src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo3}`} alt="" width={50}/>
												</Nav.Link>
											</Nav.Item>
											<Nav.Item as="li">
												<Nav.Link as="a" to="#for" eventKey="four">
													<img  className="img-fluid" src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo4}`} alt="" width={50}/>
												</Nav.Link>
											</Nav.Item>
										</Nav>
									</div>
								</Tab.Container>
							</div>

                                    </div>

                                  </div>
                        <div className="col-xl-9 col-xxl-6 col-md-6 col-sm-6">
                          <div className="card">
                          <div className="modal-header">
                    <h1 className="modal-title fs-5"> بيانات السيارة  </h1>
                                  </div>
                          <div  className="row">
                          <div className="row">
  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">اسم الزبون:</label>
    <label>{vehicle.customer?.FirstName || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">رقم اللوحة:</label>
    <label>{vehicle.LicensePlate || 'Not Added'}</label>
  </div>

 

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">نوع السيارة:</label>
    <label>{vehicle?.make?.MakeName  || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className="modal-title form-label m-2">موديل:</label>
    <label>{vehicle?.vehicle_model?.ModelName || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">السنة:</label>
    <label>{vehicle.Year || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">اللون:</label>
    <label>{vehicle.Color || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">نوع الزيت:</label>
    <label>{vehicle.VehicleType || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">نوع المحرك:</label>
    <label>{vehicle.EngineType || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">بلد الاستيراد:</label>
    <label>{vehicle.ImportCountry || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2 ">رقم الهيكل:</label>
    <label>{vehicle.ChassisNumber || 'Not Added'}</label>
  </div>

  {/* <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">Rate Type:</label>
    <label>{vehicle.RateType || 'Not Added'}</label>
  </div> */}

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className="modal-title form-label m-2"> المسافة بالكيلومتر:</label>
    <label>{vehicle.Odometer || 'Not Added'}</label>
  </div>

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">رقم المحرك:</label>
    <label>{vehicle.EngineNumber || 'Not Added'}</label>
  </div>

 

  <div className="col-xl-6 col-md-6 col-sm-12 mt-2">
    <label className=" modal-title form-label m-2">ملاحظات:</label>
    <label>{vehicle.Notes || 'Not Added'}</label>
  </div>
 
</div>

 
                                                        </div>
                                                        </div>

                                  </div>
                          </div>

                        </Tab.Pane>
                        <Tab.Pane eventKey={'cars'}>
                        <div className="container-fluid"  >
                        <Col lg={12}>
                
              <Card.Body>
              <Table responsive className="header-border">
       <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

        <tr>
          <th>اسم الزبون</th>
          <th>تالريخ الصيانة</th>
          <th>القيمة</th>
          <th>حالة اطلب الصيانة</th>
          <th>حالة الدفع</th>
          <th>رقم الفاتورة</th>
          <th>ايصال الفاتورة</th>

         </tr>
      </thead>
      <tbody>
        {listItem1.map((item, index) => (
          <tr key={index}>
            <td>{item.customer.FirstName}</td>
            <td>
              <span className="text-muted">{item.RepairDate}</span>
            </td>
            <td>${item.TotalCost}</td>
            <td>
              <Badge
                bg={
                  item.RepairStatus === "مكتملة"
                    ? "success"
                    : item.RepairStatus === "Pending"
                    ? "danger"
                    : "warning"
                }
              >
                {item.RepairStatus}
              </Badge>
            </td>
            <td>{item.Status}</td>
             <td>
                 {item.InvoiceNumber}
             </td>
            <td> <Link dir="rtl" className=""
                              to={"#"}
                              onClick={(e) => EditData5558(e,item.RepairOrderID)}
                            > <i class="fa-solid fa-file-lines fa-2x"></i>
                            </Link>

                            </td>
           </tr>
        ))}
      </tbody>
    </Table>
              </Card.Body>
           </Col>
                       
                    </div>

                        </Tab.Pane>
                      </Tab.Content>

                    </Tab.Container>
                  </div>
                </div>
               
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <InviteCustomer4
        ref={invite4} data={datareparorder} data1={datareparorderDetails}
      />
  
    
  </>
  );
});

export default Orders;
